import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';

const FieldLastName = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'settings-form-lastName',
    defaultMessage: 'Last name'
  });
  const [field, meta] = useField({name: 'lastName'});

  return (
    <InputText
      {...field}
      {...meta}
      variant={'full'}
      id={field.name}
      label={labelText}
      defaultValue={field.value}
      disabled={true}
    />
  );
};

export default FieldLastName;
